module.exports = __webpack_public_path__ + "img/10337710_753163761392747_1846333298320128279_n.6c604769.jpg";